import './OfferCard.css'

const OfferCard = ({ image, title, description }) => {
    return <div className='card'>
        <img src={image} alt={image} className="card-image"></img>
        <h3 className="card-title">{title}</h3>
        {description && <p className="card-description">{description}</p>}
    </div>;
};

export default OfferCard;